import React from "react";
import Navbar from "react-bootstrap/Navbar";
import "../style/Encabezado.css"
import logoImage from '../assets/logo.png';

export default function Encabezado() {
  return (
    <Navbar className="appbar">
      <img src={logoImage} alt="Logo" className="logo" />
    </Navbar>
  );
}
